import useUnlockOffers from '@hooks/queries/registry/unlock/useUnlockOffers';
import { useParties } from '../../contexts/PartiesContext';

export const useReceivedUnlockOffers = () => {
  const unlocks = useUnlockOffers();
  const { party } = useParties();
  const filtered = unlocks.data?.filter((offer) => offer.payload.unlock.locker === party);
  return filtered || [];
};
